"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const appSlice_1 = require("../../../store/slices/appSlice");
const SpinnerOverlay_1 = __importDefault(require("../../../components/SpinnerOverlay/SpinnerOverlay"));
const store_1 = require("../../../store/store");
const LoggedInExternal = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { user, appSettings } = (0, store_1.useAppSelector)((state) => state.app);
    const { canCreateDonorIfNotExists } = appSettings || {};
    (0, react_1.useEffect)(() => {
        const logout = (errorMessage) => {
            axios
                .get('/api/auth/logout')
                .then((response) => response.data)
                .then((logoutResponse) => {
                store_1.persistor.purge().then(() => {
                    if (logoutResponse.loggedOut) {
                        const { redirectUrl } = logoutResponse;
                        navigate('/auth/logout-external', {
                            state: Object.assign({ redirectUrl }, (errorMessage && { errorMessage: errorMessage })),
                        });
                    }
                    else {
                        navigate(`/auth/login${errorMessage ? `?error=${errorMessage}` : ''}`);
                    }
                });
            });
        };
        if (user) {
            navigate('/');
        }
        else {
            axios
                .get('/api/user')
                .then((response) => response.data.user)
                .then((userResponse) => {
                dispatch((0, appSlice_1.setUser)(userResponse));
            })
                .catch((e) => {
                if (canCreateDonorIfNotExists) {
                    navigate('/auth/create-donor');
                }
                else {
                    logout(e.status === 401 ? 'login.failed-credentials-message' : 'login.internal_server_error');
                }
            });
        }
    }, [dispatch, navigate, user, canCreateDonorIfNotExists]);
    return (0, jsx_runtime_1.jsx)(SpinnerOverlay_1.default, { visible: true });
};
exports.default = LoggedInExternal;
